// Tenant Admin renders the selected panel from route metadata rather than a
// nested <RouterView>, but Vue Router still requires a component on each
// canonical child route.
const RouteState = { render: () => null };

const iamRoute = (path, name, iamTab) => ({
  path,
  name,
  component: RouteState,
  meta: { adminTab: 'IAM Console', iamTab },
});

export const IAM_CONSOLE_ROUTES = [
  iamRoute('iam-console/users', 'AdminIAMUsers', 'users'),
  {
    path: 'iam-console/users/:id',
    name: 'AdminIAMUserDetail',
    component: () => import('@/components/Overview/Overview_Admin_User.vue'),
    props: true,
    meta: { canAccess: 'module_admin', requiresAuth: true, layout: 'default' },
  },
  iamRoute('iam-console/roles', 'AdminIAMRoles', 'roles'),
  iamRoute('iam-console/audit', 'AdminIAMAudit', 'audit'),
];
